<template>
	<div class="row flex flex-grow">
		<slot></slot>
	</div>
</template>

<script>
	export default {
	}
</script>

<style lang="stylus" scoped>
	.row {
		> .col:nth-child(n+2) {
			margin-left: .3rem;
		}

		> .module-box:nth-child(n+2) {
			margin-left: .3rem;
		}
	}
</style>
